import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProiecteService } from '../proiecte.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonService } from 'src/app/services/common.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { helper } from 'src/environments/helper';
import { IProiect, IProiectListDT } from '../proiecte.interface';
import { Subscription, catchError, combineLatest, debounceTime, distinctUntilChanged, filter, finalize, forkJoin, map, of, skip, switchMap, tap } from 'rxjs';
import { Generic } from 'src/app/interfaces/generic.interface';
import { UpdateCategorieProiectComponent } from './update-categorie-proiect/update-categorie-proiect.component';
import Swal from 'sweetalert2';
import { DialogService } from 'src/app/services/dialog.service';
import { NotificationService } from 'src/app/services/notification.service';
import { UpdateFurnizorProiectComponent } from './update-furnizor-proiect/update-furnizor-proiect.component';
import { ModalInchidereProiectComponent } from './modal-inchidere-proiect/modal-inchidere-proiect.component';
import { IHistoryEntry } from './istoric-proiect/istoric-proiect.interface';
import { StorageService } from 'src/app/services/storage.service';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/services/auth.service';
import { AppFilesService } from 'src/app/services/app-files.service';
import { UpdateCompartimentProiectComponent } from './update-compartiment-proiect/update-compartiment-proiect.component';

@Component({
    selector: 'app-detalii-proiecte',
    templateUrl: './detalii-proiecte.component.html',
    styleUrls: ['./detalii-proiecte.component.scss']
})
export class DetaliiProiecteComponent implements OnInit, OnDestroy {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;

    helper = helper;

    token!: string;
    isLoading = false;
    isLoadingOtherInfos = false;
    showIstoric = false;
    passedProiectId!: number;

    proiect!: IProiect | null;
    istoric!: IHistoryEntry[];
    motiveActive!: Generic[];
    directiiActive!: Generic[];
    operatoriTeren!: Generic[];
    sectiuni!: Generic[];

    user: any = null;

    proiectName = "";
    editProiectName = false;
    // tagName = "";
    editTagName = false;
    searchedTags: Generic[] = [];
    searchTagLoading = false;
    tagChangesSubscription = new Subscription();

    tagName = new FormControl('', [Validators.required]);
    tagId = new FormControl('', [Validators.required]);

    searchTagForm: FormGroup = new FormGroup({
        name_tag: this.tagName,
        id_tag: this.tagId,
    });

    defaultParameter: { name: string; id: number } = {
        name: '-- Alegeți --',
        id: -1,
    };

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            proiectData: IProiectListDT
        },
        private dialogRef: MatDialogRef<DetaliiProiecteComponent>,
        private dialogService: DialogService,
        private dialog: MatDialog,
        private fb: FormBuilder,
        private proiecteService: ProiecteService,
        private commonService: CommonService,
        public permissionsService: PermissionsService,
        private notificationService: NotificationService,
        private storageService: StorageService,
        private authService: AuthService,
        private appFileService: AppFilesService,
    ) {
        this.processToken();

        this.passedProiectId = this.data.proiectData.id_proiect;
        this.proiectName = this.data.proiectData.subject;
        this.tagName.setValue(this.data.proiectData.tag_name || '');
    }

    processUserDetails() {
        const userObj = this.storageService.getObject(environment.config.userKey);
        userObj
            .then((val) => {
                this.user = val;
            })
            .catch((err) => {
                console.log(err);
            });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token: string) => {
            this.token = token;
            this.proiecteService.setToken(token);
            this.processUserDetails();
        });
    }

    ngOnInit(): void {
        this.getProiectInfo(true);

        this.getOtherInfos();

        this.renderTagSearch();
    }

    ngOnDestroy(): void {
        this.tagChangesSubscription.unsubscribe();
    }

    getProiectInfo(withLoading?: boolean) {
        if (withLoading) this.isLoading = true;

        const proiect$ = this.proiecteService
            .getProiect(this.passedProiectId)
            .pipe(map((response: any) => response.data))

        const istoric$ = this.proiecteService
            .istoricMesaje(this.passedProiectId)
            .pipe(map((response: any) => response.data));

        combineLatest([proiect$, istoric$]).subscribe({
            next: ([proiect, istoric]) => {
                this.isLoading = false;

                this.proiect = proiect;
                this.istoric = istoric;
            },
            error: (error) => {
                this.isLoading = false;
                console.error('Error loading project info:', error);

                let msg;
                try {
                    msg = error.error.errors.message[0];
                } catch (error) {
                    msg = helper.dialogConfig.generalMessages.error;
                }

                this.notificationService
                    .warningSwal(this.errorTitle, msg, this.errorIcon)
                    .then((result) => {
                        this.closeDialog();
                    });
            }
        });
    }

    getOtherInfos() {
        this.isLoadingOtherInfos = true;

        forkJoin([
            this.commonService.getMotiveProiecte().pipe(
                map((results: any) => [
                    this.defaultParameter,
                    ...results,
                    { name: 'Alte observații', id: 0, }
                ])
            ),
            this.commonService.getDirectiiActive().pipe(
                map((results: any) => [this.defaultParameter, ...results])
            ),
            this.proiecteService.getOperatori().pipe(
                map((results: any) => [this.defaultParameter, ...results])
            ),
            this.commonService.getSectiuniProiecte().pipe(
                map((results: any) => [this.defaultParameter, ...results])
            )
        ]).subscribe({
            next: ([motive, directii, operatori, sectiuni]) => {
                this.motiveActive = motive;
                this.directiiActive = directii;
                this.operatoriTeren = operatori;
                this.sectiuni = sectiuni;
            },
            error: (error) => {
                let msg;
                console.error('Error loading other infos:', error);
                try {
                    msg = error.error.errors.message[0];
                } catch (error) {
                    msg = helper.dialogConfig.generalMessages.error;
                }

                this.notificationService
                    .warningSwal(this.errorTitle, msg, this.errorIcon)
                    .then((result) => {
                        this.closeDialog();
                    });
            },
            complete: () => {
                this.isLoadingOtherInfos = false;
            }
        });
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    toggleIstoric() {
        this.showIstoric = !this.showIstoric;
    }

    downloadDocument(id_document: number) {
        let fullPath = this.proiecteService.downloadDocumentURL + id_document;
        this.isLoading = true;
        this.appFileService.downloadFile(fullPath)
            .then(() => {
                this.isLoading = false;
            })
            .catch(error => {
                // Handle any errors here
                console.error('Download error:', error);
                this.isLoading = false;
            });
    }

    // Info proiect
    toggleEditProiectName() {
        this.editProiectName = !this.editProiectName;
    }
    closeEditProiectName() {
        this.editProiectName = false;
    }
    updateProiectName() {
        this.isLoading = true;
        const payload = {
            subject: this.proiectName
        }

        this.proiecteService
            .updateSubject(this.passedProiectId, payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.notificationService.warningSwal(
                        this.successTitle,
                        'Nume proiect actualizat cu succes!',
                        this.successIcon
                    ).then(() => {
                        this.closeEditProiectName();
                        this.getProiectInfo();
                    });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    toggleEditTagName() {
        this.editTagName = !this.editTagName;
    }
    closeEditTagName() {
        this.editTagName = false;
    }
    updateTagName() {
        this.isLoading = true;
        const payload = {
            id_tag: this.tagId.value
        }

        this.proiecteService
            .updateTag(this.passedProiectId, payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.notificationService.warningSwal(
                        this.successTitle,
                        'Tag actualizat cu succes!',
                        this.successIcon
                    ).then(() => {
                        this.closeEditTagName();
                        this.getProiectInfo();
                    });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
    renderTagSearch() {
        this.tagChangesSubscription = this.searchTagForm
            .controls['name_tag'].valueChanges.pipe(
                skip(1), // Ignore the first emitted value
                debounceTime(500),
                distinctUntilChanged(),
                switchMap((tagValue) => {
                    // Reset Tag ID before search
                    this.tagId.setValue('');

                    this.searchTagLoading = true;
                    return this.commonService.typeheadTagProiecte({ name: tagValue });
                }),
                tap((data: Generic[]) => {
                    this.searchTagLoading = false;
                    this.searchedTags = data;
                }),
                catchError(() => of([]))
            )
            .subscribe();
    }
    onTagSelected(option: { id: number; name: string }) {
        // Unsubscribe from valueChanges to avoid an unnecessary call to the BE when setting a value
        this.tagChangesSubscription.unsubscribe();

        this.tagName.setValue(option.name);
        this.tagId.setValue(option.id.toString());

        // Resubscribe to valueChanges after setting the value
        this.renderTagSearch();
    }

    openUpdateCategorieDialog() {
        const dialogRef = this.dialog.open(UpdateCategorieProiectComponent, {
            ...this.dialogService.getDialogConfig(),
            data: {
                proiect: this.proiect,
                sectiuni: this.sectiuni,
            },
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Informații actualizate cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                }).then(() => {
                    this.getProiectInfo();
                });
            }
        });
    }

    openUpdateCompartimentDialog() {
        const dialogRef = this.dialog.open(UpdateCompartimentProiectComponent, {
            ...this.dialogService.getDialogConfig(),
            data: {
                proiect: this.proiect,
                directiiActive: this.directiiActive,
            },
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Informații actualizate cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                }).then(() => {
                    this.getProiectInfo();
                });
            }
        });
    }

    openUpdateFurnizorDialog() {
        const dialogRef = this.dialog.open(UpdateFurnizorProiectComponent, {
            ...this.dialogService.getDialogConfig(),
            data: {
                proiect: this.proiect,
            },
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Furnizor actualizat cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                }).then(() => {
                    this.getProiectInfo();
                });
            }
        });
    }

    // Actiuni proiect
    confirmAnulareSolicitare() {
        Swal.fire({
            title: this.helper.swalTextConfig.commonTitles.areYouSure,
            text: this.helper.swalTextConfig.generalMessages.anulare,
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText:
                this.helper.swalTextConfig.validationMessages.confirmButton,
            cancelButtonText:
                this.helper.swalTextConfig.validationMessages.cancelButton,
            input: 'text', // Enable text input
            inputPlaceholder: this.helper.swalTextConfig.inputPlaceholders.cancel,
            inputValidator: (value) => {
                if (!value) {
                    return 'Este necesar completarea unui motiv..!';
                }
                return null; // Return null if input is valid
            },
            showLoaderOnConfirm: true,
            preConfirm: (inputValue) => {
                return this.proiecteService
                    .anulareProiect(this.proiect!.id_proiect, { motiv: inputValue })
                    .toPromise()
                    .then((response) => {
                        return response;
                    })
                    .catch((error) => {
                        Swal.showValidationMessage(`Request failed: ${error}`);
                    });
            },
            allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: this.helper.swalTextConfig.headers.success,
                    text: this.helper.swalTextConfig.generalMessages.successs,
                    icon: 'success',
                    confirmButtonText: this.helper.swalTextConfig.buttonLabels.close,
                }).then(() => {
                    this.getProiectInfo(true);
                });
            }
        });
    }

    openInchidereSolicitare(proiect: IProiect) {
        let dialogRef = this.dialog.open(ModalInchidereProiectComponent, {
            ...this.dialogService.getDialogConfig(),
            data: { proiect },
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.getProiectInfo(true);
            }
        });
    }

    handleButtonClick(buttonValue: string) {
        switch (buttonValue.toLowerCase()) {
            case 'anulează':
                this.confirmAnulareSolicitare();
                break;
            case 'închide':
                this.openInchidereSolicitare(this.proiect!);
                break;
            default:
                console.log('Unrecognized button value', buttonValue.toLowerCase());
        }
    }

    onIsLoadingChange(event: boolean) {
        this.isLoading = event;
    }
}
